import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import EstablishmentCreateUpdateForm from "./EstablishmentCreateUpdateForm";
import localStrings from "../../../localStrings";
import {MODE_CREATE} from "../../../components/CrudFrom/GeneralEditor";
import {Link as RouterLink} from "react-router-dom";
import {boardsRoute, dashboardBaseRoute, establishmentListRoute} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PageWithTitle from "../../../components/pages/pageWithTitle";

const EstablishmentAddView = () => {


  function getMainButtons() {
    return (


      <RouterLink to={'/' + dashboardBaseRoute + '/' + establishmentListRoute}
                  style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          variant="contained"
          startIcon={(
            <SvgIcon>
              <ArrowBackIcon />
            </SvgIcon>
          )}
        >
          {localStrings.backToBoardList}
        </Button>
      </RouterLink>
    )
  }

  return (
    <PageWithTitle title={localStrings.createEstablishment} mainButtons={getMainButtons()}>
      <EstablishmentCreateUpdateForm modeEdit={MODE_CREATE}/>
    </PageWithTitle>
  );
};

export default EstablishmentAddView;
